// src/Layout/Header/Onlinestatus.jsx
import { useCache } from '../../context/CacheContext';

function timeAgo(date) {
  if (!date) return null;
  const mins = Math.floor((Date.now() - date.getTime()) / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  return `${Math.floor(mins / 60)}h ago`;
}

const OnlineStatus = () => {
  const { isOnline, isSyncing, lastCached, pendingCount } = useCache();

  if (isSyncing) {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-full">
        <svg className="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5">
          <path d="M21 12a9 9 0 1 1-6.219-8.56" strokeLinecap="round" />
        </svg>
        <span className="text-sm font-semibold text-blue-700">Syncing…</span>
      </div>
    );
  }

  if (isOnline) {
    return (
      <div
        className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full"
        title={lastCached ? `Cache seeded ${timeAgo(lastCached)}` : 'Cache not yet seeded'}
      >
        {/* WiFi Online Icon */}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
          <path d="M5 12.55a11 11 0 0 1 14.08 0" />
          <path d="M1.42 9a16 16 0 0 1 21.16 0" />
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
          <circle cx="12" cy="20" r="1" fill="#16a34a" />
        </svg>
        <span className="text-sm font-semibold text-green-700">Online</span>
        {lastCached && (
          <span className="text-xs text-green-600 opacity-75">· {timeAgo(lastCached)}</span>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 border border-red-200 rounded-full">
      {/* WiFi Offline Icon */}
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5">
        <path d="M5 12.55a11 11 0 0 1 14.08 0" opacity="0.3" />
        <path d="M1.42 9a16 16 0 0 1 21.16 0" opacity="0.3" />
        <circle cx="12" cy="20" r="1" fill="#dc2626" />
        <line x1="2" y1="2" x2="22" y2="22" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="text-sm font-semibold text-red-700">Offline</span>
      {lastCached && (
        <span className="text-xs text-red-600 opacity-75">· cached {timeAgo(lastCached)}</span>
      )}
      {pendingCount > 0 && (
        <span className="ml-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] rounded-full bg-red-600 text-white text-[10px] font-bold px-1">
          {pendingCount}
        </span>
      )}
    </div>
  );
};

export default OnlineStatus;
